import {getCollectionDetail, getDossierDetail, getDossierInfo, dossierFilterData, getCollectionInfo, collectionFilterData, updateFavourite, followCollection} from '@/libs/api/api'
import {message, logout, errorHandler, getImageUrl, onError, copyElement, getNewCount, loader, getCatalogId} from '@/libs/helper'
import {cloneDeep, isEmpty} from 'lodash'
import constants from '@/libs/constant/constants'
import pageRoute from '@/libs/constant/pageRoutes'
export default {
    components: {
        ArticleCard: () => import('@/components/pages/InformationPortal/ProfilePage/ArticleCard/ArticleCard.vue')
    },
    data() {
        return {
            copyElement,
            getNewCount,
            isEmpty,
            getImageUrl,
            onError,
            articles: [],
            articlesToDisplay: [],
            articlesResult: {},
            searchValue: '',
            skip: 0,
            limit: 30,
            sorting: 'createdAt',
            order: 'desc',
            currentPage: 1,
            isFetchingArticles: false,
            collectionShortUrl: '',
            selectedRecord: {},
            collectionFollowersCount: 0
        }
    },
    mounted () {
        this.getArticles()
        this.getFilterData()
    },
    props: {
        module: {
            type: String,
            default: constants.ORGANISATIONS.TEAM
        },
        isDossier: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        /**
         * to fetch body on conditions
         */
        getBody () {
            // body for api
            let body = {
                entity_type: this.module
            }
            // cases
            switch (this.module) {
                case constants.ORGANISATIONS.ORGANISATION:
                    body.entity_id = this.$route.params.id 
                break
                default:
                    body.entity_id = this.$route.params.tid 
                break
            }
            // collection/dossier conditions
            if (this.isDossier) body.dossier_id = this.$route.params.cid
            else body.collection_id = this.$route.params.cid
            return body
        },

        /**
         * to get articles list
         */
        async getArticles () {
            let params = {
                skip: this.skip,
                limit: this.limit,
                order: this.order,
                sort: this.sorting
            }
            let body = await this.getBody()
            this.fetchArticles(body, params)
        },

        /**
         * for the api call conditions
         * @param {*} body 
         * @param {*} params 
         */
        fetchArticleList (body, params) {
            if (this.isDossier) return getDossierDetail(body, params)
            else return getCollectionDetail(body, params)
        },

        /**
         * api call for fetching collection articles
         */
        async fetchArticles (body, params) {
            try {
                this.isFetchingArticles = true
                // api call
                let response = await this.fetchArticleList(body, params)
                this.articles = response.items || []
                // set the articles to display
                this.articlesToDisplay = cloneDeep(response.items || [])
                // seeting the seult to make the pagination
                this.articlesResult = cloneDeep(response)
            } catch (error) {
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
            }
            this.isFetchingArticles = false
        },

        /**
         * to change the pages 
         * @param {*} currentPage 
         */
        changePage (currentPage) {
            this.currentPage = currentPage
            // setting the skip as per the current page
            this.skip = (currentPage - 1) * this.limit
            // call for fetching the articles
            this.getArticles()
        },

        /**
         * to change the sorting order
         */
        changeSortingOrder (command) {
            this.skip = 0
            this.currentPage = 1
            this.sorting = command
            this.getArticles()
        },
        /**
         * to get the collection filter data
         */
        async getFilterData () {
            try {
                let result = {}
                let response = {}
                if (this.isDossier) {
                    result = await getDossierInfo(this.$route.params.cid)
                    response = await dossierFilterData({dossier_id: this.$route.params.cid})
                    
                } else {
                    result = await getCollectionInfo(this.$route.params.cid)
                    response = await collectionFilterData({collection_id: this.$route.params.cid})
                }
                this.selectedRecord = {...result, authors: (response.authors || []), publications: (response.publications || []), publishers: (response.publishers || []),}
            } catch (error) {
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
            }
        },
        /**
         * to route to A/P/P pages
         * @param {*} meta 
         * @param {*} type 
         */
        routeToMetaPage (meta, type) {
            let id = ''
            let name = ''
            switch (type) {
                case constants.AUTHOR.key:
                    name = pageRoute.authorOverview
                    id = meta.author_id
                break
                case constants.PUBLICATION.key:
                    name = pageRoute.publicationOverview
                    id = meta.publication_id
                break
                case constants.PUBLISHER.key:
                    name = pageRoute.publisherOverview
                    id = meta.publisher_id
                break
            }
            this.$router.push({name, params: {id}})
        },
        /**
         * to get the favorite for collection/dossier
         */
        getCollectionFavorite () {
            // to check for collection/dossier
            if (this.selectedRecord && this.selectedRecord.favorites && new Set(this.selectedRecord.favorites).has(this.$store.getters.getUserInformation.id)) return true
            return false
        },
        /**
         * create/delete favorite for collection and dossier
         */
        async setCollectionFavorite () {
            try {
                loader(this, true)
                // body for api
                let isRemove = this.getCollectionFavorite()
                let body = {
                    entity_type: this.isDossier ? constants.LIST.DOSSIER : constants.LIST.COLLECTION,
                    entity_id: this.$route.params.cid
                }
                // api call
                let response = await updateFavourite(body, isRemove ? 'remove-favorite' : 'favorite')
                this.$set(this.selectedRecord, 'favorites', (response.result && response.result.favorites) || [])
                message(this, constants.messageType.SUCCESS, !isRemove ? 'marked_favorite' : 'removed_favorite')
                loader(this, false)
            } catch (error) {
                console.error(error)
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
                loader(this, false)
            }
        },
        /**
         * follow/unfollow collection and updte the count
         */
        followCollectionList () {
            loader(this, true)
            // body for api
            let body = {
                entity_type: this.isDossier ? constants.LIST.DOSSIER : constants.LIST.COLLECTION,
                entity_id: this.$route.params.cid,
                catalog_id: getCatalogId()
            }
            // api call
            followCollection(body, this.selectedRecord.is_following ? 'unfollow' : 'follow').then(async() => {
                this.selectedRecord.is_following = !this.selectedRecord.is_following
                message(this, constants.messageType.SUCCESS, `${this.selectedRecord.is_following ? ('Unfollowed Successfully') : ('Followed Successfully')}`)
                loader(this, false)
            }).catch(error => {
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
                loader(this, false)
            })
        },
        /**
         * to get short url
         */
        getShortUrlCollection() {},
    }
}